/**
 *
 * A list of all the session storage keys we use. To avoid duplicates we gather them in one file
 */

export const CONTACTS_MARKED_FOR_DELETION = 'dhContactsMarkedForDeletion';
